let $container = $("#surveyContainer");
let $form = $('.js-survey-form');
let $surveyDataEl = $('#js-survey-data');
let $completedHtmlElement = $('.js-survey-compelete-html');

let survey = {};

if (typeof surveyShema !== 'undefined') {
	initSurvey();
	enableMarkdownSupport();
	enableLocalStorageDataSaving();
}

function initSurvey() {
	
	survey = new Survey.Model(surveyShema);
	survey.locale = "ru";
	
	survey.completedHtml += $('.js-survey-compelete-html').html();
	
	if(typeof surveyData !== 'undefined') {
		survey.data = surveyData;
		survey.mode = "display";
	}
	
	if(typeof surveyIsNotActive !== 'undefined') {
		survey.mode = "display";
	}
	
	$container.Survey({model: survey});
	
	survey.onComplete.add((sender, options) => {
		sendFormData(sender);
	});
	
}

function sendFormData(sender) {
	
	const results = JSON.stringify(sender.data);
	
	$surveyDataEl.val(results);
	
	$.ajax({
		url: $form.attr('action'),
		method: $form.attr('method'),
		data: $form.serialize(),
		success: function (data) {},
	});
	
}

function enableLocalStorageDataSaving() {
	
	var storageName = "SurveyJS_LoadState_" + surveyId;
	
	function loadState(survey) {
		//Here should be the code to load the data from your database
		var storageSt = window.localStorage.getItem(storageName) || "";
		
		var res = {};
		if (storageSt) res = JSON.parse(storageSt);
		
		else res = {};
		
		//Set the loaded data into the survey.
		if (res.currentPageNo) survey.currentPageNo = res.currentPageNo;
		if (res.data) survey.data = res.data;
	}
	
	function saveState(survey) {
		var res = {currentPageNo: survey.currentPageNo, data: survey.data};
		//Here should be the code to save the data into your database
		window.localStorage.setItem(storageName, JSON.stringify(res));
	}
	
	
	survey.onCurrentPageChanged.add((survey, options) => {
		saveState(survey);
	});
	
	survey.onValueChanged.add((survey, options) => {
		saveState(survey);
	});
	
	survey.onComplete.add((sender, options) => {
		window.localStorage.removeItem(storageName);
	});
	
	loadState(survey);
	
}

function enableMarkdownSupport() {
	
	// Instantiate Showdown
	const converter = new showdown.Converter();
	
	survey.onTextMarkdown.add(function (survey, options) {
		// Convert Markdown to HTML
		let str = converter.makeHtml(options.text);
		// Remove root paragraphs <p></p>
		str = str.substring(3);
		str = str.substring(0, str.length - 4);
		// Set HTML markup to render
		options.html = str;
	});
	
}